// Resume45.js
import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Divider,
} from '@mui/material';

const Resume45 = ({ color = "#00695c" }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f5f5f5',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: '210mm',           // A4
          minHeight: '297mm',
          bgcolor: 'white',
          p: { xs: 5, md: 8 },
          pt: 7,
          pb: 8,
          fontFamily: "'Georgia', 'Times New Roman', serif",
          color: '#1a1a1a',
        }}
      >
        {/* Name & Title */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 900,
              letterSpacing: '3px',
              color: color,
              fontSize: '2.8rem',
              lineHeight: 1.1,
              mb: 1,
            }}
          >
            CONNOR HAMILTON
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: color,
              letterSpacing: '1.5px',
              fontSize: '1.35rem',
              textTransform: 'uppercase',
              mb: 1,
            }}
          >
            Real Estate Agent
          </Typography>

          <Typography sx={{ fontSize: '1rem', color: '#444' }}>
            123-456-7890  •  hello@reallygreatsite.com  •  reallygreatsite.com
          </Typography>

          <Typography sx={{ fontSize: '0.95rem', color: '#555', mt: 1 }}>
            123 Anywhere St., Any City, ST12345
          </Typography>
        </Box>

        <Divider sx={{ borderColor: color, borderWidth: 1, my: 4 }} />

        {/* PROFILE */}
        <Box sx={{ mb: 5 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: color,
              mb: 1.5,
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            PROFILE
          </Typography>

          <Typography sx={{ lineHeight: 1.9, fontSize: '0.98rem' }}>
            I am an experienced Real Estate Agent with a passion for helping clients find their dream homes. I have extensive experience in the industry, including more than 5 years working as a real estate agent. I am knowledgeable about the latest market trends and understand the nuances of the real estate market. I pride myself on my ability to negotiate the best deals for my clients and to navigate complex real estate agreements. I am highly organized, detail-oriented, and have strong communication skills.
          </Typography>
        </Box>

        <Divider sx={{ borderColor: '#888', my: 4 }} />

        {/* WORK EXPERIENCE */}
        <Box sx={{ mb: 5 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: color,
              mb: 2,
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            WORK EXPERIENCE
          </Typography>

          <Box>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: '1.15rem',
                color: '#000',
                mb: 0.5,
              }}
            >
              REAL ESTATE AGENT
            </Typography>
            <Typography sx={{ fontStyle: 'italic', color: '#555', mb: 1 }}>
              Really Great Company • June 2015 – Present
            </Typography>

            <Typography component="ul" sx={{ pl: 3, lineHeight: 2, fontSize: '0.97rem' }}>
              <li>Negotiate contracts and complex real estate transactions</li>
              <li>Provide excellent customer service to clients</li>
              <li>Update and maintain customer client files</li>
              <li>Research and monitor the local real estate market</li>
              <li>Develop marketing campaigns for properties</li>
              <li>Participate in open houses and home tours</li>
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor: '#888', my: 4 }} />

        {/* EDUCATION + SKILLS + CERTIFICATIONS – side-by-side feel */}
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 6 }}>
          {/* Left – Education + Certifications */}
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: color,
                mb: 2,
                textTransform: 'uppercase',
                letterSpacing: '1px',
              }}
            >
              EDUCATION
            </Typography>

            <Box sx={{ mb: 3 }}>
              <Typography sx={{ fontWeight: 700, color: '#000' }}>
                University
              </Typography>
              <Typography sx={{ color: '#555', fontStyle: 'italic' }}>
                2010 – 2014
              </Typography>
              <Typography sx={{ fontWeight: 600 }}>
                B.A. in Business Administration
              </Typography>
            </Box>


         
          </Box>

          {/* Right – Skills */}
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: color,
                mb: 2,
                textTransform: 'uppercase',
                letterSpacing: '1px',
              }}
            >
              SKILLS
            </Typography>

            <Typography component="ul" sx={{ pl: 3, lineHeight: 2.1, fontSize: '0.97rem' }}>
              <li>Knowledge of the local real estate market</li>
              <li>Communication skills</li>
           
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export const resumeMeta = {
  hasPhoto: false,
  columns: 1,
  colorOptions: [
    { value: "#00695c", label: "Deep Teal" },
    { value: "#d84315", label: "Fiery Orange" },
    { value: "#283593", label: "Indigo" },
    { value: "#558b2f", label: "Forest Green" },
    { value: "#6a1b9a", label: "Deep Purple" }
  ]
};

export default Resume45;